/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntegrationConnectionHealth } from './IntegrationConnectionHealth';
import type { IntegrationConnectionStatus } from './IntegrationConnectionStatus';
import type { WhatsAppIntegrationCustomFields } from './WhatsAppIntegrationCustomFields';
/**
 * Interface representing a WhatsApp integration DTO.
 */
export type WhatsAppIntegration = {
    tenantId: string;
    providerName: WhatsAppIntegration.providerName;
    integrationType: WhatsAppIntegration.integrationType;
    providerId: string;
    userId: string;
    integrationFields: WhatsAppIntegrationCustomFields;
    /**
     * High-level connection status, set by the Integrations service.
     * When missing, treat as `active` for backwards compatibility.
     */
    connectionStatus?: IntegrationConnectionStatus;
    /**
     * Health fields used by periodic connection checks.
     */
    connectionHealth?: IntegrationConnectionHealth;
    createdAt: string;
    activatedAt: string;
};
export namespace WhatsAppIntegration {
    export enum providerName {
        WHATSAPP = 'whatsapp',
    }
    export enum integrationType {
        MESSAGING = 'messaging',
    }
}

